import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CommonButton, CustomLeftIcon } from "../../../common/StyledComponents/StyledFields";
import { useEffect, useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import styles from "../../../devoteeService/devoteeService.module.scss"
import { apiRequest } from "../../../../infrastructure/backendService";
import { CMS_BASE_URL } from "../../../../config/apiUrl";
import { useReactToPrint } from 'react-to-print';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const EventsHtmlContent = () => {
    const [loading, setLoading] = useState(false)
    const [loaderPrint, setLoaderPrint] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [HTMLPage, setHTMLPage] = useState<any>(null);
    const [searchParam] = useSearchParams();
    const eventType = searchParam.get("eventType")
    const eventName = searchParam.get("eventName")
    const eventTypeLower = eventType ? eventType.toLowerCase() : "";
    const eventNameLower = eventName ? eventName.toLowerCase() : "";

    useEffect(() => {
      apiRequest({
          basePath: `${CMS_BASE_URL}`,
          method: "GET",
          endpoint: eventType === "specialEvents" ? "/wp-json/wp/v2/specialevents?per_page=100" : "/wp-json/wp/v2/upcomingevents?per_page=100",
      })
          .then((res) => {
              const event = res.data.find((event: any) => event.acf.event_title === eventName);
              setHTMLPage(event?.acf?.html_page);
          })
          .catch((err) => {
              console.log(err);
          });
  }, [])

    const handlebackClick = () => {
        navigate('/')
    }
    useEffect(() => {
        window.scroll(0, 200)
    }, [])
    
    const pdfRef = useRef<any>();

  const handlePrint = useReactToPrint({
    content: () => pdfRef.current,
  });

  const handleDownload = async () => {
    setLoading(true);

    const canvas = await html2canvas(pdfRef.current, {
      scale: 2, // High-quality capture
      useCORS: true, // Allow cross-origin images
      allowTaint: false, // Prevent tainting
    });

    const imgData = canvas.toDataURL("image/png"); // Convert the canvas to image data

    // A4 page dimensions in pixels (96 DPI)
    const a4Width = 595; // A4 width for portrait
    const a4Height = 842; // A4 height for portrait

    const pdf = new jsPDF({
      orientation: "portrait", // Fixed orientation
      unit: "px", // Use pixels for consistent measurements
      format: [a4Width, a4Height], // A4 page size in portrait
    });

    // Scale content to fit within A4 while maintaining aspect ratio
    const aspectRatio = canvas.width / canvas.height;

    // Determine scaling factors
    let pdfWidth = a4Width; // Fixed width
    let pdfHeight = pdfWidth / aspectRatio; // Scaled height to maintain ratio

    // Check if the height exceeds the A4 dimensions
    if (pdfHeight > a4Height) {
      pdfHeight = a4Height; // Adjust to fit A4 height
      pdfWidth = pdfHeight * aspectRatio; // Adjust width accordingly
    }

    pdf.addImage(
      imgData,
      "PNG", // Image type
      0, // X-coordinate
      0, // Y-coordinate
      pdfWidth, // Adjusted width
      pdfHeight // Adjusted height
    );

    pdf.save(`${eventTypeLower}_${eventNameLower}.pdf`); // Save the PDF

    setLoading(false);
  };

    return (
      <div>
        <div style={{marginBottom:"24px"}}>
        <div onClick={handlebackClick} style={{ marginLeft: "20px" }}>
          <CustomLeftIcon />
        </div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            float: "right",
            marginTop: "-30px",
          }}
          className={styles.printHidden}
        >
          <CommonButton onClick={handlePrint} disabled={loaderPrint}>
            {loaderPrint ? (
              <>
                <ClipLoader color="#fff" loading={loaderPrint} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Printing...
                </span>
              </>
            ) : (
              "Print"
            )}
          </CommonButton>
          <CommonButton disabled={loading} onClick={handleDownload}>
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Downloading...
                </span>
              </>
            ) : (
              "Download"
            )}
          </CommonButton>
        </div>
        </div>
         <div
          ref={pdfRef}
          dangerouslySetInnerHTML={{ __html: HTMLPage }}
        />

        {/* <iframe src={location.state.key} width="1000" height="800"></iframe> */}
      </div>
    );
};

export default EventsHtmlContent;
